import PropTypes from 'prop-types';
import React from 'react';
import cx from 'classnames';

const FilterEditorStep = ({children, selected, onClick}) => (
  <div
    onClick={onClick}
    className={cx(
      'FilterEditor__Step',
      selected && 'FilterEditor__Step--selected'
    )}
  >
    {children}
  </div>
);

FilterEditorStep.propTypes = {
  selected: PropTypes.bool.isRequired,
  onClick: PropTypes.func,
};

FilterEditorStep.defaultProps = {
  selected: false,
};

export default FilterEditorStep;
